export const socialLinks = [
	{
		id: 1,
		name: 'Website',
		icon: 'globe',
		url: 'https://www.velaire.xyz/',
	},
	{
		id: 2,
		name: 'GitHub',
		icon: 'github',
		url: '',
	},
	{
		id: 3,
		name: 'Twitter',
		icon: 'twitter',
		url: '',
	},
	{
		id: 4,
		name: 'LinkedIn',
		icon: 'linkedin',
		url: '',
	},
	{
		id: 5,
		name: 'YouTube',
		icon: 'youtube',
		url: '',
	},
];
